<template>
    <div class="main-body">
        <div class="header">物品列表</div>
        <div class="out">

            <div class="search2">

              <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

              <div style="float:right">

                <el-select v-model="institutionCode" placeholder="请选择机构">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>

                  <el-button size="mini" style="margin-left:5px;float:right" type="primary" icon="el-icon-search" plain @click="getList">搜索</el-button>
              </div>

              <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border>

                <el-table-column prop="name" label="物品名称"></el-table-column>

                <el-table-column prop="price" label="单价"></el-table-column>

                <el-table-column prop="supplierName" label="供应商"></el-table-column>

                <el-table-column prop="waresTypeName" label="物品类型"></el-table-column>

              <el-table-column prop="stock" label="库存">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="handleInfo(scope.$index, scope.row)">{{scope.row.stock}}</el-button>
                </template>
              </el-table-column>

              <el-table-column prop="specifications" label="规格"></el-table-column>
              <el-table-column prop="manufacturer" label="生产企业"></el-table-column>
              <el-table-column prop="remark" label="备注"></el-table-column>




              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                </template>
              </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList" v-bind:arr_ins="arr_ins"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList" v-bind:arr_ins="arr_ins"></Edit>

      <StockInInfo ref="myStockInInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"></StockInInfo>


    </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Edit from "./Edit";
    import Add from "./Add";
import StockInInfo from "../Ins/StockInInfo";


    export default {
        name: "Role",
        data(){
            return{
                loading:false,


                showModalAdd:false,
                showModalEdit:false,
              showModalInfo:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,
              th:0,

                supplierCode:'',
                waresTypeCode:'',
                warehouseCode:'',

                SupplierCodeValue:[],
                WaresTypeCodeValue:[],
                warehouseCodeValue:[],


              arr_ins:[],
              institutionCode: '',

            }
        },
        components:{
            Add,Edit,StockInInfo
        },
        created(){
            this.getIns();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

          getIns(){

            this.$axios({
              method: 'post',
              url: this.$shopUrl+"Institution/ListType",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                staffCode: getStaffCode(),
                type:1,
              }
            }).then((response) => {

              if (response.data.error === 0) {
                this.arr_ins = response.data.data.list;
                if(this.arr_ins.length>0){
                  this.institutionCode = this.arr_ins[0].institutionCode;
                  this.getList();
                }
              }else if(response.data.error === 1){
                this.$message.error(response.data.message)
              }

            })

          },

          toggleModalAdd:function(){
              this.showModalAdd = !this.showModalAdd;
              this.$refs.myAdd.init();
          },
          closeAdd:function(){
              this.showModalAdd = !this.showModalAdd;
          },

          handleEdit(index, row) {
            this.$refs.myEdit.init(row);
            this.showModalEdit = !this.showModalEdit;
          },
          closeEdit:function(){
              this.showModalEdit = !this.showModalEdit;
          },

          handleInfo(index, row) {
            this.$refs.myStockInInfo.init(row);
            this.showModalInfo = !this.showModalInfo;
          },
          closeInfo:function(){
            this.showModalInfo = !this.showModalInfo;
          },


          current_change:function(currentPage){
              this.currentPage = currentPage;
              this.getList();
          },
          getList(){
              this.loading=true;

              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+"Wares/GovPageIns",
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      staffCode: getStaffCode(),
                    institutionCode:this.institutionCode,
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                  }
              }).then( (response)=> {
                  this.loading=false;

                  if(response.data.error == 0){
                      this.tableData = response.data.data.list;
                      this.totalItems = response.data.data.total;
                  }else if(response.data.error == 1){
                      this.$message({type: 'info', message: response.data.message});
                  }

              }).catch(function (error) {
                  console.log(error);
              });
          },

          statusTitle(row){
              if(row.status == 0){
                  return "正常";
              }
              if(row.status == 1){
                  return "禁用";
              }
              return "其它";
          },

          timefilter(row, column, cellValue){
            return timefilters(cellValue)
          },



        }
    }
</script>

<style lang='scss' scoped>


</style>
